export interface VolumeBin {
  /** Inclusive lower bound of the bin. */
  min: number
  /** Legend label, e.g. "11–20". */
  label: string
  /** Tailwind background class for cells in this bin. */
  className: string
}

// Discrete single-hue ramp — binned rather than continuous so neighboring
// cells are comparable at a glance. Sized to read up to ~100 calls/hr.
//
// NB: the brand palette is only a monotonic blue from brand-25 → brand-800;
// brand-900 is purple (#42307D) and brand-950 near-black, so the ramp stops
// at brand-800.
export const CALL_VOLUME_BINS: ReadonlyArray<VolumeBin> = [
  { min: 1, label: '1–2', className: 'bg-doubleNickel-brand-100' },
  { min: 3, label: '3–5', className: 'bg-doubleNickel-brand-200' },
  { min: 6, label: '6–10', className: 'bg-doubleNickel-brand-300' },
  { min: 11, label: '11–20', className: 'bg-doubleNickel-brand-400' },
  { min: 21, label: '21–40', className: 'bg-doubleNickel-brand-500' },
  { min: 41, label: '41–70', className: 'bg-doubleNickel-brand-700' },
  { min: 71, label: '71+', className: 'bg-doubleNickel-brand-800' },
]

export const ZERO_BIN_CLASS = 'border border-doubleNickel-gray-100 bg-white'

export const binClass = (value: number): string => {
  if (value <= 0) return ZERO_BIN_CLASS
  let result = CALL_VOLUME_BINS[0].className
  for (const bin of CALL_VOLUME_BINS) {
    if (value >= bin.min) result = bin.className
  }
  return result
}
